// Nome da skill em .claude/skills/add-personalized-invite: renomear os dois juntos
const SKILL_COMMAND = '/add-personalized-invite';

export const buildClaudeRequest = ({ snippet, clientName, personContextId }) =>
  `${SKILL_COMMAND} ${JSON.stringify({
    clientName,
    personContextId,
    logoFileName: snippet.logoFileName,
    bannerFileName: snippet.bannerFileName,
    imports: snippet.imports,
    definitions: snippet.definitions,
    mapEntry: snippet.mapEntry,
  })}`;
